// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"73":"5f4319a5","317":"c2aa10bf"}[chunkId] + ".css";
};